// eslint-disable-next-line import/no-extraneous-dependencies
import register from '@babel/register';

register({
  extensions: ['.js', '.jsx', '.ts', '.tsx', '.svg'],
});
